import { addOrRemoveString, CheckboxGroup } from "@cerebruminc/cerebellum";
import { useLocation, useSearch } from "@tanstack/react-router";
import { useAtomValue, useSetAtom } from "jotai";
import { navigateApp } from "src/lib/app-router";
import { availableFiltersAtom } from "src/shame/shame-atoms";
import { UserTableFilterIds } from "../types";
import { contentWidth } from "src/components/FiltersModal/FiltersModal";
import { TAB_PADDING_LEFT, TAB_PADDING_RIGHT } from "src/components/FiltersModal/FiltersModalStyles";
import { TabFormContainer } from "src/components/FiltersModal/TabFormContainer";
import React from "react";
import { forcedTableLoadingAtom } from "src/shame/shame-atoms";
import { normalizeSearchParam, removeQueryParamFromRouter } from "../helpers";

const checkboxAndGap = 27;
const scrollbarAndGutter = 14;
const TAB_ID = UserTableFilterIds.Role;

export function RoleForm({ allFilters }: { allFilters: any }) {
	const availableFilters = useAtomValue(availableFiltersAtom);
	const setForcedTableLoading = useSetAtom(forcedTableLoadingAtom);
	const location = useLocation();
	const search = useSearch({ strict: false }) as Record<string, unknown>;

	const maxLabelWidth = contentWidth - scrollbarAndGutter - TAB_PADDING_LEFT - TAB_PADDING_RIGHT - checkboxAndGap;

	const typeCheckedFilters = normalizeSearchParam(search[TAB_ID]);

	const noActiveFilters = typeCheckedFilters?.length === 0;

	return (
		<TabFormContainer tabId={TAB_ID} allFilters={allFilters} title="Roles" noActiveFilters={noActiveFilters}>
			<CheckboxGroup
				activeValues={typeCheckedFilters}
				checkboxes={availableFilters?.roles?.map((item) => ({
					label: item.label,
					value: item.value,
				}))}
				label=" "
				maxLabelWidth={maxLabelWidth}
				name={TAB_ID}
				onClick={(event) => {
					setForcedTableLoading(true);
					const newValue = addOrRemoveString({
						array: normalizeSearchParam(search.roles),
						string: event.target.value,
					});
					if (newValue.length) {
						navigateApp({ search: { ...search, roles: newValue }, to: location.pathname });
					} else {
						removeQueryParamFromRouter({ paramKey: "roles", pathname: location.pathname, search });
					}
				}}
			/>
		</TabFormContainer>
	);
}
